import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "modal",
    "form",
    "sessionSlotId",
    "sessionName",
    "sessionDate",
    "recipientsList",
    "recipientCount",
    "messageInput",
    "submitBtn",
    "submitCount"
  ]

  static values = {
    defaultMessage: {
      type: String,
      default: "Bonjour,\n\nVous n'avez pas encore signé votre présence pour la session \"{session_name}\" du {date}.\n\nMerci de procéder à la signature dès que possible.\n\nCordialement"
    }
  }

  connect() {
    this.selectedUsers = []
  }

  openSingleModal(event) {
    const { userId, userName, userEmail, sessionSlotId, sessionName, sessionDate } = event.params

    this.selectedUsers = [{ id: userId, name: userName, email: userEmail }]
    this.populateModal(sessionSlotId, sessionName, sessionDate)
    this.showModal()
  }

  openBulkModal(event) {
    const { sessionSlotId, sessionName, sessionDate, users } = event.params

    const parsedUsers = typeof users === "string" ? JSON.parse(users) : users
    this.selectedUsers = parsedUsers.filter(u => u.id)
    this.populateModal(sessionSlotId, sessionName, sessionDate)
    this.showModal()
  }

  populateModal(sessionSlotId, sessionName, sessionDate) {
    this.sessionSlotIdTarget.value = sessionSlotId
    this.sessionNameTarget.textContent = sessionName
    this.sessionDateTarget.textContent = sessionDate

    this.renderRecipientsList()
    this.updateCounts()

    const message = this.defaultMessageValue
      .replace("{session_name}", sessionName)
      .replace("{date}", sessionDate)
    this.messageInputTarget.value = message
  }

  renderRecipientsList() {
    this.recipientsListTarget.innerHTML = this.selectedUsers.map(user => `
      <label class="flex items-center justify-between p-3 hover:bg-gray-50 cursor-pointer">
        <div class="flex items-center gap-3">
          <input type="checkbox"
                 name="user_ids[]"
                 value="${user.id}"
                 checked
                 class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                 data-action="change->reminder#updateCounts">
          <div>
            <p class="text-sm font-medium text-gray-900">${this.escapeHtml(user.name)}</p>
            <p class="text-xs text-gray-500">${this.escapeHtml(user.email || "")}</p>
          </div>
        </div>
      </label>
    `).join("")
  }

  updateCounts() {
    const checkboxes = this.recipientsListTarget.querySelectorAll('input[type="checkbox"]')
    const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length

    this.recipientCountTarget.textContent = `(${checkedCount})`
    this.submitCountTarget.textContent = `(${checkedCount})`

    this.submitBtnTarget.disabled = checkedCount === 0
    this.submitBtnTarget.classList.toggle("opacity-50", checkedCount === 0)
    this.submitBtnTarget.classList.toggle("cursor-not-allowed", checkedCount === 0)
  }

  showModal() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")

    requestAnimationFrame(() => {
      this.messageInputTarget.focus()
    })

    document.addEventListener("keydown", this.handleEscape)
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.handleEscape)
  }

  handleEscape = (event) => {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  escapeHtml(text) {
    if (!text) return ""
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
  }
}
